import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479a6dd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "general" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Crear Cuenta")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Por favor, ingrese sus datos", -1))
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "grid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm",
  for: "name"
}, "Nombre Completo", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm mt-4",
  for: "email"
}, "Correo electrónico", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm mt-4",
  for: "username"
}, "Usuario", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm mt-4",
  for: "password"
}, "Contraseña", -1))
const _hoisted_14 = ["type"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm mt-4",
  for: "confirmPassword"
}, "Confirmar Contraseña", -1))
const _hoisted_16 = ["type"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Mostrar Contraseñas ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "¿Ya tienes cuenta?", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Iniciar Sesión")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "img",
            src: 
        'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
      
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("img", { src: 
            'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
           }, null, 8, _hoisted_4),
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("h6", _hoisted_7, _toDisplayString($data.error), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  id: "name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.usuario.name) = $event))
                }, null, 512), [
                  [_vModelText, $data.usuario.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  id: "email",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.usuario.email) = $event))
                }, null, 512), [
                  [_vModelText, $data.usuario.email]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  id: "username",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.usuario.username) = $event))
                }, null, 512), [
                  [_vModelText, $data.usuario.username]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: $data.passwordFieldType,
                  id: "password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.usuario.password) = $event))
                }, null, 8, _hoisted_14), [
                  [_vModelDynamic, $data.usuario.password]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: $data.passwordFieldType,
                  id: "password",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.confirmPassword) = $event))
                }, null, 8, _hoisted_16), [
                  [_vModelDynamic, $data.confirmPassword]
                ])
              ]),
              _createElementVNode("fieldset", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (this.togglePasswordFieldType())),
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.flexCheckDefault) = $event)),
                    id: "flexCheckDefault"
                  }, null, 544), [
                    [_vModelCheckbox, $data.flexCheckDefault]
                  ]),
                  _hoisted_19
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($options.signup()), ["prevent"]))
          }, " Crear Cuenta "),
          _hoisted_20,
          _createElementVNode("h6", null, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ], 64))
}